module.exports = __webpack_public_path__ + "static/img/max-bender-VmX3vmBecFE-unsplash_thumb.b37da3e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/max-bender-VmX3vmBecFE-unsplash_thumb.png
// module id = Np/d
// module chunks = 4